const toppers = [
  {
    year: "Batch 2020-24",
    data: [
      {
        category: "Electronics & Telecommunication Engineering",
        students: [
          {
            rank: 1,
            name: "Gawas Narayan Dhayaba",
            cgpi: 9.79,
            img: "https://i.ibb.co/CHp0qkF/image1.jpg",
          },
          {
            rank: 2,
            name: "Aditya Charudatta Kulkarni",
            cgpi: 9.67,
            img: "https://i.ibb.co/hcZJrgy/image3.jpg",
          },
          {
            rank: 3,
            name: "Nishali Dhanshika Gowri Venkadeshaaral",
            cgpi: 9.59,
            img: "https://i.ibb.co/WfLkhxR/image2.jpg",
          },
        ],
      },
      {
        category: "Electronics Engineering",
        students: [
          {
            rank: 1,
            name: "Dedhia Fenil Bharat",
            cgpi: 9.21,
            img: "https://i.ibb.co/0M0r5H8/image5.jpg",
          },
          {
            rank: 2,
            name: "Jogi Harshita Umesh",
            cgpi: 9.04,
            img: "https://i.ibb.co/k42pd5n/image4.png",
          },
          {
            rank: 3,
            name: "Surve Bhavesh Sadanand",
            cgpi: 9.03,
            img: "https://i.ibb.co/wWqXxYS/image7.png",
          },
        ],
      },
    ],
  },
  {
    year: "Batch 2019-23",
    data: [
      {
        category: "Electronics & Telecommunication Engineering",
        students: [
          {
            rank: 1,
            name: "Agrawal Khushi Kirtesh",
            cgpi: 9.81,
            img: "https://i.ibb.co/DgyhMNQ/image6.jpg",
          },
          {
            rank: 2,
            name: "Gupta Garima Devesh",
            cgpi: 9.75,
            img: "https://i.ibb.co/xLjCDQQ/image9.png",
          },
          {
            rank: 3,
            name: "Arora Prerna Jitendrakumar",
            cgpi: 9.71,
            img: "https://i.ibb.co/qxwL94L/image8.png",
          },
        ],
      },
      {
        category: "Electronics Engineering",
        students: [
          {
            rank: 1,
            name: "Asodekar Eeshaan Paresh",
            cgpi: 9.77,
            img: "https://i.ibb.co/1bXyPXw/image12.jpg",
          },
          {
            rank: 2,
            name: "Dave Jenil Mayank",
            cgpi: 9.73,
            img: "https://i.ibb.co/JqTG6cL/image10.jpg",
          },
          {
            rank: 3,
            name: "Sutar Pushkar Ramesh",
            cgpi: 9.61,
            img: "https://i.ibb.co/WcgK17Y/image11.jpg",
          },
        ],
      },
    ],
  },
  {
    year: "Batch 2018-22",
    data: [
      {
        category: "Electronics & Telecommunication Engineering",
        students: [
          {
            rank: 1,
            name: "Chaluvadi LV Aditi Umadevi",
            cgpi: 9.96,
            img: "https://i.ibb.co/1dZfxdq/image13.jpg",
          },
          {
            rank: 2,
            name: "Jain Vansh Madhu",
            cgpi: 9.83,
            img: "https://i.ibb.co/7WnYqXd/image14.jpg",
          },
          {
            rank: 3,
            name: "Kaustubh Venkatesh Hemamalini",
            cgpi: 9.77,
            img: "https://i.ibb.co/RPMKtY2/image15.jpg",
          },
        ],
      },
      {
        category: "Electronics Engineering",
        students: [
          {
            rank: 1,
            name: "Naik Isha Deepak Jayshree",
            cgpi: 9.91,
            img: "https://i.ibb.co/s52qpx6/image16.jpg",
          },
          {
            rank: 2,
            name: "Vasant Nisha Nitesh Jigna",
            cgpi: 9.89,
            img: "https://i.ibb.co/BjSNcSW/image17.jpg",
          },
          {
            rank: 3,
            name: "Sanghvi Kunal Sanjay Julie",
            cgpi: 9.88,
            img: "https://i.ibb.co/tQs8m9J/image18.jpg",
          },
        ],
      },
    ],
  },
];

export default toppers;
